import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.CompanyInfoPage.PopupTransferImpossible', {
    title: 'Request to is not possible',
    description: 'Transfer of this organisation cannot be requested, please contact sales to proceed.',
    contactSalesButton: 'CONTACT SALES',
});
